// @flow

import {
  DND_OVERLAY_SET_IS_DRAGGING,
  DND_OVERLAY_SET_DND_STATE,
  DND_OVERLAY_SET_BUTTON_VISIBLE,
} from 'actions/dndOverlay';

import DND_STATES from 'components/DNDOverlay/states';

type State = {
  +isDragging: boolean,
  +dndState: ?$Keys<typeof DND_STATES> | null,
  +buttonVisible: boolean,
};

type Payload = State & { type: string };

const INITIAL_STATE: State = {
  isDragging: false,
  dndState: null,
  buttonVisible: false,
};

export default function(
  state: State = INITIAL_STATE,
  { type, dndState, isDragging, buttonVisible }: Payload
): State {
  switch (type) {
    case DND_OVERLAY_SET_IS_DRAGGING:
      return {
        ...state,
        isDragging,
      };

    case DND_OVERLAY_SET_DND_STATE:
      return {
        ...state,
        dndState,
      };

    case DND_OVERLAY_SET_BUTTON_VISIBLE:
      return {
        ...state,
        buttonVisible,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/dndOverlay.js